<script>
    import router from "page";

    import { getLocaleResource } from "../utils/locales.js";

    // import Datalist from "../components/Datalist.svelte";
    import DatalistDebounced from "../components/DatalistDebounced.svelte";
    import UserDropdown from "./UserDropdown.svelte";
    import UserSelect from "./UserSelect.svelte";

    import {
        isAuthenticated,
        isAdmin,
        isSales,
        salesCompanyKey,
        activePage,
        client,
        cartCount,
        searchInput,
        showSidebar,
        isMobile,
        locale,
    } from "../stores.js";

    import {
        fetchGet,
        fetchPost,
        fetchDelete,
        fetchPatch,
    } from "../utils/utilsFetch";

    function toggleSidebar() {
        $showSidebar = !$showSidebar;
    }

    // DATALIST ===============================================================

    async function getProductsForDatalist(value) {
        if (value?.length >= 3) {
            let products = await fetchGet(`/api/products/datalist?q=${value}`);

            return products;
        }
    }

    async function navigateToDatalistSelectedProduct(sku) {
        router(`/products/${sku}`);
    }

    function onEnterCallback(searchQuery) {
        router(`/products?search=${searchQuery}`);
    }
</script>

<div class="container">
    <div
        class="menu-toggle fas fa-bars"
        on:click={toggleSidebar}
        style="margin-right: 10px;"
    />

    <a
        href={$isSales && $salesCompanyKey && $salesCompanyKey !== "null"
            ? `/?salesCompanyKey=${$salesCompanyKey}`
            : "/"}
    >
        <div class="logo">
            <img src="/logo.png" />
        </div>
    </a>

    {#if !$isAdmin}
        <DatalistDebounced
            styleGroup="margin-right: 20px;"
            styleInput={$isMobile ? "width: 160px;" : ""}
            styleDropdown={$isMobile ? "width: 338px; margin-left: -80px;" : ""}
            datalistPopulationCallback={getProductsForDatalist}
            datalistSelectionCallback={navigateToDatalistSelectedProduct}
            {onEnterCallback}
            key={null}
            value={null}
            settings={{
                keyFormat: "sku",
                headers: [
                    { text: "", width: 25 },
                    { text: getLocaleResource($locale, "sku"), width: 100 },
                    { text: getLocaleResource($locale, "product"), width: 600 },
                ],
                optionValueFormat: [
                    { key: "sku", width: 100 },
                    { key: "productName", width: 600 },
                ],
                image: {
                    url: "/pics/resampled",
                    width: 25,
                },
                descriptionNull: "",
                clearAfterSelection: true,
            }}
            placeholder={`${getLocaleResource($locale, "search")}...`}
        />

        {#if $isMobile}
            <a href="/cart" class="cart" style="margin-right: 10px;">
                <button class="btn btn-green">
                    <i class="fas fa-shopping-cart" />
                    <div class="count">
                        {#if $cartCount}
                            {$cartCount}
                        {/if}
                    </div>
                </button>
            </a>
        {/if}

        {#if $isMobile}
            <div class="user">
                <UserDropdown />
            </div>
        {/if}

        <div class="links links-left">
            <!-- <a href="/brands">
                <div class="nav-item" class:active={$activePage == "brands"}>
                    {getLocaleResource($locale, "brands")}
                </div>
            </a> -->

            <!-- https://globo-lighting.ba/wp-content/uploads/2022/08/GLOBO-Vision-13-AT-72dpi.pdf -->

            <a
                href="https://globo-lighting.ba/blog/3d-flip-book/vision-13"
                target="_blank"
            >
                <div class="nav-item" class:active={$activePage == "catalogue"}>
                    Katalog
                </div>
            </a>

            <a
                href="https://www.globo-lighting.com/unternehmen/schauraum/oesterreich"
                target="_blank"
            >
                <div class="nav-item" class:active={$activePage == "showroom"}>
                    3D showroom
                </div>
            </a>

            {#if $isSales && $isMobile}
                <UserSelect />
            {/if}
        </div>

        {#if !$isMobile}
            <div class="links links-right" class:right={!$isMobile}>
                <a href="/sale">
                    <div class="nav-item" class:active={$activePage == "sale"}>
                        {getLocaleResource($locale, "onSale")}
                    </div>
                </a>

                <a href="/new">
                    <div class="nav-item" class:active={$activePage == "new"}>
                        {getLocaleResource($locale, "newProducts")}
                    </div>
                </a>

                <a href="/carts">
                    <div class="nav-item" class:active={$activePage == "carts"}>
                        <!-- <i class="fas fa-th" /> -->
                        {getLocaleResource($locale, "carts")}
                    </div>
                </a>

                <a href="/orders">
                    <div
                        class="nav-item"
                        class:active={$activePage == "orders"}
                    >
                        <!-- <i class="fas fa-th" /> -->
                        {getLocaleResource($locale, "orders")}
                    </div>
                </a>

                <a href="/invoices">
                    <div
                        class="nav-item"
                        class:active={$activePage == "invoices"}
                    >
                        <!-- <i class="fas fa-th" /> -->
                        {getLocaleResource($locale, "invoices")}
                    </div>
                </a>

                <a href="/finance">
                    <div
                        class="nav-item"
                        class:active={$activePage == "finance"}
                    >
                        <!-- <i class="fas fa-th" /> -->
                        {getLocaleResource($locale, "finance")}
                    </div>
                </a>
            </div>

            <a href="/cart" class="cart" style="margin-right: 20px;">
                <button class="btn btn-green">
                    <i class="fas fa-shopping-cart" />
                    <div class="label">
                        {getLocaleResource($locale, "cart")}
                    </div>
                    <div class="count">
                        {#if $cartCount}
                            {$cartCount}
                        {/if}
                    </div>
                </button>
            </a>

            {#if $isSales}
                <div style="margin-right: 20px;">
                    <UserSelect />
                </div>
            {/if}
        {/if}
    {:else}
        <div class="links links-right">
            <a href="/admin/users" style="margin-left: 20px;">
                <div class="nav-item" class:active={$activePage == "users"}>
                    {getLocaleResource($locale, "users")}
                </div>
            </a>

            <a href="/admin/imports">
                <div class="nav-item" class:active={$activePage == "imports"}>
                    {getLocaleResource($locale, "orders")}
                </div>
            </a>

            {#if $isMobile}
                <div class="user" style="margin-left: auto;">
                    <UserDropdown />
                </div>
            {/if}
        </div>
    {/if}

    <!-- <span style="color:red; font-size: 10px;">
        {$client.companyKey} &gt; {$salesCompanyKey}
    </span> -->

    {#if !$isMobile}
        <div class="user" class:right={$isAdmin}>
            <UserDropdown />
        </div>
    {/if}
</div>

<style>
    .container {
        grid-column: 1/-1;
        grid-row: 1/2;

        display: flex;
        align-items: center;

        padding: 0px 5px;
        background: #333;

        z-index: 99;
    }

    .logo {
        width: 40px;
        display: flex;
        align-items: center;
        margin-right: 10px;
    }

    .logo img {
        width: 100%;
    }

    .links {
        display: flex;
        align-items: center;
        gap: 20px;
    }

    .links-left {
        margin-left: 20px;
    }

    .links-right {
        margin-right: 20px;
    }

    .nav-item {
        color: #888;
        /* margin-right: 20px; */
    }

    .nav-item:hover {
        color: white;
    }

    .active {
        color: white;
    }

    .right {
        margin-left: auto;
    }

    .info {
        color: white;
        margin-right: 10px;
    }

    .logout {
        color: red;
        cursor: pointer;
    }

    .label {
        margin-left: 5px;
    }

    .count {
        margin-left: 5px;
        opacity: 0.5;
    }

    .menu-toggle {
        font-size: 30px;
        color: #999;
        cursor: pointer;
    }

    @media only screen and (max-device-width: 600px) {
        .container {
            flex-wrap: wrap;
        }

        .links-left {
            margin-left: 0px;
            width: 100%;
            display: flex;
            justify-content: space-evenly;
            padding-bottom: 5px;
        }

        .links-right {
            margin-right: 0px;
        }

        .nav-item {
            font-size: 14px;
            margin-right: 10px;
        }

        .cart,
        .user {
            margin-left: auto;
        }
    }
</style>
